<template>
  <v-container style="max-width:1080px;">
    <div ref="nicehash" style="height: 600px;" />
  </v-container>
</template>

<script>
import axios from "axios";
import Highcharts from "highcharts";

export default {
  name: "Chart",
  async mounted() {
    const { data } = await axios.get("https://8xiscecoe2.execute-api.ap-northeast-1.amazonaws.com/production/hashpower/nicehash/history?platform=NICEHASH-STANDARD&algo=SHA256&from=" + Math.round(Date.now() / 1000 - 86400 * 7));

    Highcharts.chart(this.$refs.nicehash, {
      title: {
        text: 'Nicehash price & speed.',
        style: {
          color: 'white'
        }
      },

      credits: {
        enabled: false
      },

      chart: {
        backgroundColor: '#000',
        style: {
          fontFamily: '"Roboto", Helvetica, Arial, sans-serif'
        }
      },

      colors: ['#2b908f', '#cece4b'],

      yAxis: [
        {
          title: {
            text: 'speed',
            style: { color: 'white' }
          },
          labels: {
            style: { color: '#ccc' }
          },
          min: 0,
        }, {
          title: {
            text: 'price',
            style: { color: 'white' }
          },
          labels: {
            style: { color: '#ccc' }
          },
          min: 0,
          opposite: true
        }
      ],

      tooltip: {
        shared: true
      },

      xAxis: {
        type: 'datetime',
        labels: {
          style: { color: '#ccc' }
        },
        endOnTick: false
      },

      legend: {
        enabled: false
      },

      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          }
        }
      },

      series: [{
        name: 'Speed',
        type: 'area',
        yAxis: 0,
        tooltip: {
          valueDecimals: 2,
          valueSuffix: 'PH/s'
        },
        data: data.map(v => [v.hour * 1000, v.volume / 10 ** 15])
      }, {
        name: 'Price',
        yAxis: 1,
        tooltip: {
          valueDecimals: 5,
          valueSuffix: 'BTC/PH/s'
        },
        data: data.map(v => [v.hour * 1000, v.price * 10 ** 15])
      }],
    });
  }
}
</script>

<style scoped>

</style>